var Message_Beta = /** @class */ (function () {
    function Message_Beta() {
        this.company = "";
        this.pxDataStatus = "";
        this.stopmsg = false;
    }
    return Message_Beta;
}());
export { Message_Beta };
